import forms_en from './forms_en.json'
import insurancePlans_en from './insurance-plans_en.json'
import interactions_en from './interactions.json'

const baseUSFlow_resources = {
  en: {
    ...forms_en,
    ...insurancePlans_en,
    ...interactions_en,
  },
}

export default baseUSFlow_resources
